 
import React, { useEffect } from 'react';
import { reportProps } from './StopLossAggregateTable';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { BasicTable } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { getKpiPopupColumns } from '../core-utils/helper-utils/kpiPopupHelper';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import DownArrow from '../_components/atoms/Icons/DownArrow';
import { getFormatterForTitle } from '../core-utils/helper-utils/experienceHelper';

const CohortInsightTable: React.FC<reportProps> = ({ data }) => {
  const useStyles = makeStyles()({
    tableCell: {
      display: 'flex',
      justifyContent: 'center',
      gap: '5px',
      alignItems: 'center',
    },
  });

  const { classes } = useStyles();

  const getKpiRowsFromCohort = (title: string, cohortSection: any) => {
    const rowData: any[] = [];
    cohortSection?.forEach((item: any) => {
      const eachRow: any[] = [];
      eachRow.push(
        <Grid className={classes.tableCell} style={{ width: '100px' }}>
          <Typography fontSize="12px">{item?.cohort_old_rank}</Typography>
        </Grid>,
      ),
        eachRow.push(
          item?.cohort_trend === 'neutral' ? (
            <Typography
              textColor={patientAccessTheme.palette.text.mediumemphasis}
              className={classes.tableCell}
              style={{ width: '100px' }}
            >
              -
            </Typography>
          ) : (
            <Grid className={classes.tableCell} style={{ width: '100px' }}>
              <DownArrow
                fill={
                  item?.cohort_trend === 'decreasing' ? `#00BDA5` : `#E8696D`
                }
                style={{
                  transform:
                    item?.cohort_trend === 'decreasing'
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)',
                }}
              />
              <Typography
                fontSize="12px"
                textColor={
                  item?.cohort_trend === 'decreasing' ? `#00BDA5` : `#E8696D`
                }
              >
                {item?.cohort_rank_jump === '^' ? '' : item?.cohort_rank_jump}
              </Typography>
            </Grid>
          ),
        ),
        eachRow.push(
          <Grid className={classes.tableCell} style={{ width: '100px' }}>
            {' '}
            <Typography fontSize="12px">{item?.cohort_new_rank}</Typography>
          </Grid>,
        ),
        eachRow.push(
          <Grid
            className={classes.tableCell}
            style={{ justifyContent: 'left', width: '350px' }}
          >
            <Typography
              fontSize="12px"
              fontType="medium"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
            >
              {item.cohort_name}
            </Typography>
          </Grid>,
        );
      eachRow.push(
        <Grid
          className={classes.tableCell}
          style={{ justifyContent: 'left', width: '200px' }}
        >
          <Typography
            fontSize="12px"
            fontType="medium"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
          >
            {item.cohort_category}
          </Typography>
        </Grid>,
      );
      if (item.aggregated_data) {
        const {
          aggregated_cost_column_1_value,
          aggregated_cost_column_2_value,
        } = item.aggregated_data;

        eachRow.push(
          <Grid className={classes.tableCell}>
            <Typography
              fontSize="12px"
              fontType="medium"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
            >
              {getFormatterForTitle('surge')(item.value)}
            </Typography>
          </Grid>,
        );
        eachRow.push(
          <Grid className={classes.tableCell}>
            <Typography
              fontSize="12px"
              fontType="medium"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
            >
              {getFormatterForTitle('top spending')(
                aggregated_cost_column_1_value,
              )}
            </Typography>
          </Grid>,
        );

        // Push second aggregated column
        eachRow.push(
          <Grid className={classes.tableCell}>
            <Typography
              fontSize="12px"
              fontType="medium"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
            >
              {getFormatterForTitle('top spending')(
                aggregated_cost_column_2_value,
              )}
            </Typography>
          </Grid>,
        );
      } else {
        // Push single value column (no change)
        eachRow.push(
          <Grid className={classes.tableCell}>
            <Typography
              fontSize="12px"
              fontType="medium"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
            >
              {getFormatterForTitle(title)(item.value)}
            </Typography>
          </Grid>,
        );
      }

      eachRow.push(
        <Grid className={classes.tableCell}>
          <Typography
            fontSize="12px"
            fontType="medium"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
          >
            {item.unique_claimants_count}
          </Typography>
        </Grid>,
      );

      rowData.push(eachRow);
    });

    return rowData;
  };

  useEffect(() => {}, []);
  return (
    <BasicTable
      width={'100%'}
      displayType="box"
      cellHeight="36px"
      tableBodyStyles={{
        '& .MuiTableCell-body': {
          color: patientAccessTheme.palette.text.mediumemphasis,
          fontSize: '12px',
          fontWeight: 'inherit !important' as any,
        },
        '& .MuiTableRow-root': {
          '&:last-child': {
            fontWeight: 700,
            fontSize: '14px',
          },
        },
      }}
      columns={getKpiPopupColumns(
        data?.analysis_duration,
        data?.result?.[0]?.aggregated_data,
        data?.aggregated_cost_column_1_header,
        data?.aggregated_cost_column_2_header,
      )}
      rowsData={
        data?.result?.length !== 0
          ? getKpiRowsFromCohort(data?.analysis_type, data?.result)
          : []
      }
    />
  );
};
export default CohortInsightTable;
